import * as L from 'leaflet'
import '../utils/context-menu/CreateContextMenus.js'
import 'leaflet-simple-map-screenshoter'

import baseMap from "../mixins/base-map.js"

import {OBJECT} from '@/utils/map/types'
import saveFile from '../../../utils/saveFile'
import measureMixin from '../mixins/measure-mixin'
import ThreadsDrawer from "../utils/ThreadsDrawer";
import url from "../../../utils/url";
import {map as mapEndpoints}    from "../../../api/api-endpoints";
import {MAP}                    from '@/config/map';
import {threadsDateSliderMixin} from "./threads/date-slider";

export const forecastMixin = {
  data () {
    this.map = null;
    return {
      popups: {
        showMapPopup: false,
        showMapPopupCreate: false,
        showMapPopupDelete: false,
        showRefreshTariff: false
      },
      suggestionMapSearch: {q: ''},
      addYearFormShow: false,
      q: '',
      optimizeThreads: false,
      showRight: true,
      showMapCard: false
    }
  },
  mixins: [baseMap, measureMixin, threadsDateSliderMixin],
  watch: {
    'optimizeThreads': 'optimizeThreadsHandler'
  },
  computed: {
    tariffRegion(){
      return this.$store.getters.readUrlEndpoint(this.getMapModelingRegionTariff())
    },
    tariffLegendRegion(){
      return this.$store.getters.readUrlEndpoint(this.getTariffLegend())
    },
    forecasts() {
      return this.$store.getters.readUrlEndpoint(this.getThreadEndpoint(this.$route))
    },
    threadsSettlements () {
      return this.forecasts ? this.forecasts.threadsSettlements : []
    },
    threadsTkoObjects () {
      return this.forecasts?.threadsTkoObjects?.length ? this.forecasts.threadsTkoObjects : []
    },
    threadsTkoObjectsById () {
      let tmp = [];
      let threadsTkoObjects = this.threadsTkoObjects;
      for (let key in threadsTkoObjects) {
        tmp[threadsTkoObjects[key].id] = threadsTkoObjects[key]
      }
      return tmp
    },
    notInThreadTkoObjectsById () {
      let threads = this.threads;
      let existTkoObjectIds = {};
      for (let key in threads) {
        let thread = threads[key];
        existTkoObjectIds[thread.tko_object_id] = thread.id
      }

      let mapTkoObjects = this.mapTkoObjectsById;
      let tmp = [];
      for (let key in mapTkoObjects) {
        if (!existTkoObjectIds[key]) {
          tmp[key] = mapTkoObjects[key]
        }
      }
      return tmp
    },
    threadsSettlementsById () {
      let tmp = [];
      let threadsSettlements = this.threadsSettlements;
      for (let key in threadsSettlements) {
        tmp[threadsSettlements[key].id] = threadsSettlements[key]
      }
      return tmp
    },
    threads () {
      let nodes = {};
      let threadsRawData = this.forecasts || {};
      let threadsRaw = threadsRawData.threads || [];
      let threadsTkoObjectsById = this.threadsTkoObjectsById;
      let realTkoObjectById = this.mapTkoObjectsById;
      let threadsSettlementsById = this.threadsSettlementsById;

      threadsRaw.forEach(relation => {
        let {id, threads_tko_object_id, threads_settlement_id, start_threads_tko_object_id} = relation;
        if(!threads_tko_object_id) {
          return;
        }
        nodes[id] = {};

        try {

          // всятаялем инфу по связи
          nodes[id] = Object.assign({}, relation);

          // вставляем данные объекта тко из threadsTkoObjects
          nodes[id] = Object.assign(nodes[id], threadsTkoObjectsById[threads_tko_object_id]);
          let tko_object_id = threadsTkoObjectsById[threads_tko_object_id].tko_object_id;
          // вставляем данные настоящего объекта
          nodes[id] = Object.assign(nodes[id], realTkoObjectById[tko_object_id]);

          // вставляем id настоящего города
          nodes[id].settlement_id = threads_settlement_id ? threadsSettlementsById[threads_settlement_id].locality_id : null;
          // вставляем id настоящего города или отходообразователя
          if(threads_settlement_id) {
            if (threadsSettlementsById[threads_settlement_id].garbage_source_id) {
              nodes[id].settlement_id = threadsSettlementsById[threads_settlement_id].garbage_source_id || null;
              nodes[id].garbage_source_id = threadsSettlementsById[threads_settlement_id].garbage_source_id
            }
          }
          // ставим id ребра
          nodes[id].thread_id = id;

          nodes[id].id = tko_object_id;
  
          // если стартовая вершина это объект
          if (start_threads_tko_object_id) {
            // const startThreadsTkoObject = threadsTkoObjectsById[start_threads_tko_object_id]
            let startTkoObjectId = threadsTkoObjectsById[start_threads_tko_object_id]?.tko_object_id;
            if (!startTkoObjectId) {
              delete nodes[id]
            }
            let startRealTko = realTkoObjectById[startTkoObjectId];
            nodes[id].start_tko_object_id = startTkoObjectId;
            if(startRealTko){
              nodes[id].start_object_lat = startRealTko.lat;
              nodes[id].start_object_lng = startRealTko.lng
            } else {
              delete nodes[id]
            }
          }
        } catch (e) {
          console.error(e)
          // delete nodes[id]
        }
      });
      
      return nodes
    },
    suggestionMapSearchOptions () {
      let tmp = [];
      let settlements = this.threadsSettlementsById;
      if (settlements) {
        for (let key in settlements) {
          if(!settlements[key].name) {
            continue
          }
          // see type definition in src/app/geo/utils/ThreadsDrawer.js
          tmp.push({
            id: settlements[key].id + OBJECT.CITY,
            name: settlements[key].name
          })
        }
      }
      let mapTkoObjects = this.mapTkoObjects;
      if (mapTkoObjects) {
        for (let key in mapTkoObjects) {
          // TODO: do not search by removed
          mapTkoObjects[key].forEach(v => {
            tmp.push({
              id: v.id + OBJECT.TKO,
              name: v.name + ' ' + v.address
            })
          })
        }
      }
      return tmp
    }
  },
  mounted () {
    this.simpleMapScreenshoter = L.simpleMapScreenshoter({
      hidden: true
    }).addTo(this.map)
    this.$on('localityDrawKostil', function () {
      this.showModelTariffsHandle(this.showModelTariffs)
    })
    this.refreshMap()
  },
  methods: {
    afterMapInit() {
      this.threadsDrawer = new ThreadsDrawer(this.map, this);
      this.subsSetView = this.$emitter.listen('geo.mapSetView', this.setView);
      this.subsUpdateMap = this.$emitter.listen('geo.mapUpdate', this.updateMap);
      this.subsRefreshMap = this.$emitter.listen('geo.mapRefresh', this.refreshMap)
    },
    destroyMap () {
      console.log('destroyed');
      this.$emitter.emit('geo.destroyMap', {});
      this.map = null
    },
    destroyAsync () {
      this.$store.commit('skipAsyncData', {name: 'geo.*', depth: 1, value: false});
      if (this.subsSetView) {
        this.subsSetView.unsubscribe()
      }
      if (this.subsUpdateMap) {
        this.subsUpdateMap.unsubscribe()
      }
      if (this.subsRefreshMap) {
        this.subsRefreshMap.unsubscribe()
      }
      if (this.threadsDrawer) {
        this.threadsDrawer.destroy()
      }
    },
    selectItemOnMapSearch ($event) {
      this.suggestionMapSearch.q = $event.name;
      this.$bar.start().set(12);
      setTimeout(() => {
        let foundObject = this.findObjectById($event.id);
        if (!foundObject) {
          this.$e.errorBox('Объект не найден');
          console.error('Check the types and id, maybe tko object id are lost');
          return
        }
        foundObject.type = $event.id.indexOf(OBJECT.TKO) > -1 ? OBJECT.TKO : OBJECT.CITY;
        this.threadsDrawer.bringToMarker(foundObject, 13);
        this.$bar.finish()
      }, 50)
    },
    findObjectById (findId) {
      let res = [];
      if(findId.indexOf(OBJECT.TKO) > -1){
        res = Object.values(this.mapTkoObjectsById).filter(obj => findId === `${obj.id}${OBJECT.TKO}`)
      }
      if(findId.indexOf(OBJECT.CITY) > -1) {
        res = this.threadsSettlementsById.filter(obj => findId === `${obj.id}${OBJECT.CITY}`)
      }
      return res[0] || null
    },
    popUpMapShow(open, close) {
      this.$set(this.popups, open, !this.popups[open]);
      close.forEach(i=>{
        this.$set(this.popups, i, false);
      })
    },
    popUpUpdateClose() {
      this.$set(this.popups, 'showMapPopup', false);
    },
    popUpCreateClose() {
      this.refreshMap();
      this.$set(this.popups, 'showMapPopupCreate', false);
    },
    popUpDeleteClose() {
      this.refreshMap();
      this.$set(this.popups, 'showMapPopupDelete', false);
    },
    popUpRefreshTariffClose() {
      this.refreshMap();
      this.$set(this.popups, 'showMapPopupDelete', false);
    },
    optimizeThreadsHandler () {
      this.replaceRoute({optimizeThreads: this.optimizeThreads});
      this.$store.dispatch('updateUrlEndpoint', {endpoint: this.getThreadEndpoint(this.$route)}).then(() => this.refreshMap())
    },
    getAndSaveScreenshot () {
      this.$bar.start();
      let {lat, lng} = this.map.getCenter();
      let zoom = this.map.getZoom();
      let fileName = `Прогноз за ${this.year} год. Ш ${lat.toFixed(3)} Д ${lng.toFixed(3)} М ${zoom} .png`;
      let caption = `Прогноз за ${this.year} год. Координаты центра карты - широта: ${lat.toFixed(5)}, долгота: ${lng.toFixed(5)}, масштаб: ${zoom}. Дата создания: ${new Date().toLocaleString()}`;
      this.simpleMapScreenshoter.takeScreen('blob', {
        caption
      }).then(blob => {
        console.log('blobScreenshot', blob);
        saveFile({blob, fileName});
        this.$bar.finish()
      }).catch(e => {
        // @fix: TypeError: Failed to execute 'createObjectURL' on 'URL': No function was found that matched the signature provided.
        this.$bar.finish();
        console.error(e);
        this.$e.warningBox(
          'Превышен объем доступной памяти вашего компьютера: закройте неиспользуемые программы, увеличьте масштаб карты, обновите страницу (Ctrl+R) и повторите попытку снова'
        )
      })
    },
    letSearch () {
      this.replaceRoute({q: this.q, optimizeThreads: this.optimizeThreads}, false)
    },
    getAndSaveKML () {
      this.$bar.start();
      this.$store.dispatch('downloadFile', {
        endpoint: this.getDownloadKMLEndpoint()
      }).then(r => {
        this.$bar.finish();
        saveFile({
          blob: r.request.response,
          headers: r.headers
        })
      }).catch(e => {
        this.$bar.finish();
        this.$e.errorBox(e)
      })
    },
    getAndSaveShapefile () {
      this.$bar.start();
      this.$store.dispatch('downloadFile', {
        endpoint: this.getDownloadShapefileEndpoint()
      }).then(r => {
        this.$bar.finish();
        saveFile({
          blob: r.request.response,
          headers: r.headers
        })
      }).catch(e => {
        this.$bar.finish();
        this.$e.errorBox(e)
      })
    },
  },
  asyncData ({store, route, methods}) {
    let promises = [];
    let usedRoute = url.getPrevOrCurrentRoute(route);
    if(methods.getThreadEndpoint){
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getThreadEndpoint(route, usedRoute),
        fromCache: true
      }))
    }
    if(methods.getSettlementEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getSettlementEndpoint(route, usedRoute),
        fromCache: true
      }))
    }
    if(methods.getMapModelingRegionTariff) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getMapModelingRegionTariff(),
        fromCache: true
      }))
    }

    if(methods.getUnauthorizedHeapsEndpoint){
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getUnauthorizedHeapsEndpoint(route),
        fromCache: true
      }))
    }

    if(methods.getMSNContainersEndpoint){
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getMSNContainersEndpoint(route),
        fromCache: true
      }))
    }

    if (methods.getMapTkoObjectsEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getMapTkoObjectsEndpoint(route),
        fromCache: true
      }))
    }
    
    if (methods.getTariffLegend) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getTariffLegend(),
        fromCache: true
      }))
    }
    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
      fromCache: true
    }));

    return Promise.all(promises)
  },
  destroyed () {
    this.destroyMap();
    this.destroyAsync()
  },
};
